import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { AuthLayout } from "../components/layouts";
import SignIn from "../views/auth/SignIn";
import Editor from "../views/Editor";

const PublicRouter = () => {
  return (
    <Router>
      <AuthLayout>
        <Switch>
          <Route exact path="/" component={SignIn} />
          <Route exact path="/editor" component={Editor} />
          <Route path="*" component={() => <Redirect to="/" />} />
        </Switch>
      </AuthLayout>
    </Router>
  );
};

export default PublicRouter;